import { ResetPasswordView } from '@/views/ResetPasswordView';

const ResetPasswordPage = () => <ResetPasswordView />;
export default ResetPasswordPage;
